<body>
    <div class="container">
        <h1>Privacy Policy</h1>
        <p>Effective Date: January 12, 2025</p>
        <p>Last Updated: January 12, 2025</p>
        <p>At <strong>UberME</strong> ("we," "our," "us"), we value your privacy and are committed to protecting your
            personal information. This Privacy Policy outlines how we collect, use, and share your data when you use our
            app and services. It also explains your rights and how to contact us regarding privacy matters.</p>

        <h2>1. Information We Collect</h2>
        <ul>
            <li><strong>Personal Information:</strong> Name, email, phone number, and payment details when you register
                or make transactions.</li>
            <li><strong>Usage Data:</strong> Information about your interactions with our app, such as activity,
                searches, and preferences.</li>
            <li><strong>Location Data:</strong> Precise or approximate location data for location-based features (e.g.,
                nearby cars).</li>
            <li><strong>Device Data:</strong> Device type, operating system, and IP address to optimize performance.
            </li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul>
            <li>Provide and enhance our services.</li>
            <li>Process bookings, payments, and transactions securely.</li>
            <li>Personalize your app experience and offer location-based services.</li>
            <li>Analyze app performance and usage patterns for improvement.</li>
            <li>Communicate updates, offers, and important notifications.</li>
        </ul>

        <h2>3. Data Sharing</h2>
        <p>We do not sell your personal data. However, we may share your information in these cases:</p>
        <ul>
            <li><strong>With Service Providers:</strong> Payment processors, analytics providers, and support partners.
            </li>
            <li><strong>Legal Compliance:</strong> If required by law or to protect our legal rights.</li>
            <li><strong>With Your Consent:</strong> When you explicitly approve sharing your data with specific parties.
            </li>
        </ul>

        <h2>4. Data Retention and Deletion</h2>
        <ul>
            <li><strong>Retention:</strong> We retain your personal data as long as necessary to provide our services
                and comply with legal obligations.</li>
            <li><strong>Deletion:</strong> You can request the deletion of your account and associated data by
                contacting us.</li>
        </ul>

        <h2>5. Security Measures</h2>
        <p>We implement robust security measures to protect your data against unauthorized access, loss, or misuse.
            While no system can guarantee complete security, we work continuously to safeguard your information.</p>

        <h2>6. Your Rights</h2>
        <ul>
            <li>Access and review your personal data.</li>
            <li>Request corrections to inaccurate information.</li>
            <li>Delete your account and associated data.</li>
            <li>Opt-out of marketing communications or tracking technologies.</li>
        </ul>

        <h2>7. Cookies and Tracking Technologies</h2>
        <p>We may use cookies and similar technologies to enhance your experience and analyze app performance. You can
            manage your cookie preferences through your device settings.</p>

        <h2>8. Updates to This Policy</h2>
        <p>We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements.
            Significant updates will be communicated in advance. The "Effective Date" at the top indicates the last
            update.</p>

        <h2>9. Contact Us</h2>
        <p>For questions, concerns, or data-related requests, please contact us:</p>
        <ul>
            <li><strong>Email:</strong> <a href="mailto:privacy@uberme.xyz">privacy@uberme.xyz</a></li>
            <li><strong>Address:</strong> UAE, Dubai,Busniess Bay, Marasi Drive, EWAN 2 401</li>
            <li><strong>Phone:</strong> +971-50-319-8324</li>
        </ul>

        <div class="footer-note">
            <p>© 2025 UberME. All rights reserved.</p>
            <p>This Privacy Policy is available at: <a
                    href="https://www.uberme.xyz/privacy-policy">https://www.uberme.xyz/privacy-policy</a></p>
        </div>
    </div>
</body>